module.exports = __webpack_public_path__ + "assets/icon-installationType-permanent.6078c882.svg";